import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  quickLinkIcon: {
    color: theme.palette.primary.main,
    fontSize: theme.spacing(4),
  },
  backstageIcon: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}));
